var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,i){return _c('div',{key:i},[_c('NotiCardItem',{attrs:{"item":item},on:{"onAccept":_vm.onAccept}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }